import type {
  RestCreatePaymentMethod,
  RestPaymentMethod,
  RestUpdatePaymentMethod,
} from "@KassaroAB/shared/types/paymentMethods/paymentMethod";
import type { PaymentMethodId, StoreId } from "@KassaroAB/shared/types/ids";
import { api } from "../utils/api";

export const getPaymentMethodsApi = async (
  storeId: StoreId,
): Promise<RestPaymentMethod[]> => {
  return api.get(`stores/${storeId}/paymentMethods`);
};

export const getPaymentMethodApi = async (
  storeId: StoreId,
  paymentMethodId: PaymentMethodId,
): Promise<RestPaymentMethod> => {
  return api.get(`stores/${storeId}/paymentMethods/${paymentMethodId}`);
};

export const createPaymentMethodApi = async (
  storeId: StoreId,
  paymentMethod: RestCreatePaymentMethod,
): Promise<RestPaymentMethod> => {
  return api.post(`stores/${storeId}/paymentMethods`, paymentMethod);
};

export const updatePaymentMethodApi = async (
  storeId: StoreId,
  paymentMethodId: PaymentMethodId,
  paymentMethod: RestUpdatePaymentMethod,
): Promise<RestPaymentMethod> => {
  return api.put(
    `stores/${storeId}/paymentMethods/${paymentMethodId}`,
    paymentMethod,
  );
};

export const deletePaymentMethodApi = async (
  storeId: StoreId,
  paymentMethodId: PaymentMethodId,
): Promise<void> => {
  return api.delete(`stores/${storeId}/paymentMethods/${paymentMethodId}`);
};
